import memoize from 'lru-memoize'
import { createValidator, email } from 'utility/validation'

const createOrganizationInviteValidation = createValidator({
  recipient_email: [email],
})

export default memoize(10)(createOrganizationInviteValidation)
